module.exports = __webpack_public_path__ + "static/media/calendar.8454d73f.svg";